<template>
  <div
    class="base-button-container"
    v-if="!isNotDefault && !isEditButton && !isMobile"
  >
    <v-btn
      v-bind="$attrs"
      :data-ruid="'base-button-' + title.replace(/\s+/g, '-').toLowerCase()"
      :height="$attrs.height || 48"
      class="base-button"
      elevation="0"
      @click.native="$emit('pressed')"
    >
      <slot name="default">
        {{ title }}
      </slot>
    </v-btn>
    <slot name="footer" />
  </div>
  <div
    class="base-button-container-mobile-default"
    v-else-if="!isNotDefault && !isEditButton && isMobile"
  >
    <v-btn
      v-bind="$attrs"
      :data-ruid="'base-button-' + title.replace(/\s+/g, '-').toLowerCase()"
      :height="$attrs.height || 48"
      class="base-button"
      elevation="0"
      @click.native="$emit('pressed')"
    >
      <slot name="default">
        {{ title }}
      </slot>
    </v-btn>
    <slot name="footer" />
  </div>
  <div
    class="base-button-container-notdefault"
    v-else-if="isNotDefault && !isEditButton && !isMobile"
  >
    <v-btn
      v-bind="$attrs"
      :data-ruid="'base-button-' + title.replace(/\s+/g, '-').toLowerCase()"
      :height="$attrs.height || 48"
      class="base-button"
      elevation="0"
      @click.native="$emit('pressed')"
    >
      <slot name="default">
        {{ title }}
      </slot>
    </v-btn>
    <slot name="footer" />
  </div>
  <div
    class="base-button-container-mobile"
    v-else-if="isNotDefault && !isEditButton && isMobile"
  >
    <v-btn
      v-bind="$attrs"
      :data-ruid="'base-button-' + title.replace(/\s+/g, '-').toLowerCase()"
      :height="$attrs.height || 48"
      class="base-button"
      elevation="0"
      @click.native="$emit('pressed')"
    >
      <slot name="default">
        {{ title }}
      </slot>
    </v-btn>
    <slot name="footer" />
  </div>
  <div class="base-button-container-edit" v-else-if="isEditButton">
    <v-btn
      v-bind="$attrs"
      :data-ruid="'base-button-' + title.replace(/\s+/g, '-').toLowerCase()"
      :height="$attrs.height || 48"
      class="base-button"
      elevation="0"
      @click.native="$emit('pressed')"
    >
      <slot name="default">
        {{ title }}
      </slot>
    </v-btn>
    <slot name="footer" />
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component({
  name: "BaseButton",
  inheritAttrs: false,
})
export default class BaseButton extends Vue {
  @Prop({ default: false }) readonly title!: string;

  @Prop({ default: false }) readonly isNotDefault!: boolean;

  @Prop({ default: false }) readonly isMobile!: boolean;

  @Prop({ default: false }) readonly isEditButton!: boolean;
}
</script>

<style lang="scss">
.base-button-container {
  .base-button {
    box-shadow: 0px 5px 25px rgba(210, 210, 210, 0.5);
    border-radius: 25.5px;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    height: 40px !important;
    color: $primary_button_text_color;
    text-transform: none !important;

    &.v-btn--depressed {
      box-shadow: 0px 5px 25px rgba(210, 210, 210, 0.5) !important;
    }

    .v-btn__content {
      padding: 0 10px;
      letter-spacing: normal;
    }
  }
}
.base-button-container-mobile-default {
  .base-button {
    box-shadow: 0px 5px 25px rgba(210, 210, 210, 0.5);
    border-radius: 25.5px;
    font-size: 10px;
    font-weight: bold;
    text-align: center;
    height: 30px !important;
    width: 80px !important;
    color: #000000;
    text-transform: none !important;

    &.v-btn--depressed {
      box-shadow: 0px 5px 25px rgba(210, 210, 210, 0.5) !important;
    }

    .v-btn__content {
      padding: 0 10px;
      letter-spacing: normal;
    }
  }
}
.base-button-container-mobile {
  .base-button {
    box-shadow: 0px 5px 25px rgba(210, 210, 210, 0.5);
    border-radius: 25.5px;
    font-size: 10px;
    font-weight: bold;
    text-align: center;
    height: 30px !important;
    width: 80px !important;
    color: #000000;
    text-transform: none !important;

    &.v-btn--depressed {
      box-shadow: 0px 5px 25px rgba(210, 210, 210, 0.5) !important;
    }

    .v-btn__content {
      padding: 0 10px;
      letter-spacing: normal;
    }
  }
}
.base-button-container-notdefault {
  .base-button {
    box-shadow: 0px 5px 25px rgba(210, 210, 210, 0.5);
    border-radius: 25.5px;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    height: 40px !important;
    color: #000000;
    text-transform: none !important;

    &.v-btn--depressed {
      box-shadow: 0px 5px 25px rgba(210, 210, 210, 0.5) !important;
    }

    .v-btn__content {
      padding: 0 10px;
      letter-spacing: normal;
    }
  }
}
.base-button-container-edit {
  .base-button {
    box-shadow: 0px 5px 25px rgba(210, 210, 210, 0.5);
    border-radius: 25.5px;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    height: 40px !important;
    color: #000000;
    text-transform: none !important;
    border: solid 1px #d4d7de;

    &.v-btn--depressed {
      box-shadow: 0px 5px 25px rgba(210, 210, 210, 0.5) !important;
    }

    .v-btn__content {
      padding: 0 10px;
      letter-spacing: normal;
    }
  }
}
</style>
